import { boolean, object, string } from "yup";
import { defaultContextFields, generateDateBeforeNowValidationRule, hospital, } from "../../shared.js";
export const hpdPart1DataSchema = object({
    ...defaultContextFields({}),
    updateUserProfession: string()
        .default(null)
        .required("Please select the option which applies")
        .oneOf(["registeredMedicalPractitioner", "approvedClinician"]),
    updateSection: string()
        .default(null)
        .oneOf(["section52", "section54"])
        .required("Please select the option which applies"),
    updateSectionText: string(),
    hospital: hospital,
    updateReasonForDischarge: string()
        .default(null)
        .oneOf([
        "expireOfTimeframe",
        "noMhaAssessment",
        "notConsideredCriteria",
        "patientFurtherDetained",
        "other",
    ])
        .required("Please state section patient is subject to"),
    updateReasonForDischargeText: string(),
    reasonForDischargeOther: string()
        .nullable()
        .optional()
        .when("updateReasonForDischarge", {
        is: (value) => value === "other",
        then: () => string().required("Please enter reason for discharge"),
        otherwise: () => string().optional(),
    }),
    remainingInHospitalInformalPatient: boolean()
        .default(null)
        .required("Please select either yes or no"),
    dischargeFromDetention: generateDateBeforeNowValidationRule("date-time", "User cannot enter a date in the future.").required("Please enter date and time of discharge"),
});
export const exampleHPDData = [
    {
        data: {
            user: {
                name: "Clinician",
                email: "david@clinician.com",
                address: "Clinician Address",
                postalCode: "ABC 123",
                isConfirmed: true,
                isSection12Approved: true,
                isGuest: true,
            },
            patient: {
                name: "Patient",
                address: "Patient Address",
                postalCode: "ABC 123",
                dateOfBirth: "1990-01-01",
                nhsNumber: "1234567890",
            },
            hospital: {
                name: "Hospital",
                address: "Hospital Address",
                postalCode: "ABC 123",
                isConfirmed: true,
            },
            updateUserProfession: "registeredMedicalPractitioner",
            updateSectionText: "Section 5(2)",
            updateSection: "section52",
            updateReasonForDischargeText: "Expire of timeframe",
            updateReasonForDischarge: "expireOfTimeframe",
            remainingInHospitalInformalPatient: true,
            dischargeFromDetention: "2003-04-05T18:30:00.000Z",
        },
    },
];
//# sourceMappingURL=hpd.js.map